/* src/app/components/shared/model/shipping-address-dialog/shipping-address-dialog.component.scss */
.shippingAddressDialog .dialog-title {
  color: #FFFFFF;
  font-size: 21px;
}
.shippingAddressDialog .header {
  background-color: var(--theme-deafult-secondary);
}
.shippingAddressDialog .header-tab-action {
  background: rgba(0, 0, 0, 0.1490196078) !important;
  margin: 0px 5px;
  border-radius: 10px;
  color: #FFFFFF;
}
.shippingAddressDialog .mat-mdc-dialog-content {
  margin: 0px;
  padding: 23px 25px;
}
.shippingAddressDialog .mat-mdc-dialog-content .borderBox {
  border: 1px solid #e0e0e0;
}
.shippingAddressDialog .mat-mdc-dialog-content .p-15 {
  padding: 15px !important;
}
.shippingAddressDialog .mat-mdc-dialog-actions {
  margin: 0px;
  padding: 23px 25px;
}
.shippingAddressDialog .mat-mdc-dialog-actions .updateButton {
  background-color: var(--theme-deafult);
  color: #FFFFFF;
}
.c-1 {
  color: var(--theme-deafult);
}
::ng-deep .shippingAddressDialog .mat-mdc-dialog-container {
  margin: 0px;
  padding: 0px !important;
}
.material-icons.color_white {
  color: #ffffff;
}
.close-button {
  float: right;
  top: -24px;
  right: -24px;
}
.close-icon {
  transition: 1s ease-in-out;
}
.close-icon:hover {
  transform: rotate(180deg);
}
::ng-deep .shippingAddressDialog .close-button {
  float: right;
  top: -52px;
  right: -52px;
}
::ng-deep .shippingAddressDialog .mat-mdc-dialog-container {
  overflow: unset;
}
/*# sourceMappingURL=shipping-address-dialog.component.css.map */
